import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Icon from '../../components/AppIcon';
import LoginForm from './components/LoginForm';
import { useAuth } from '../../contexts/AuthContext';

export default function AuthenticationAndRoleSelection() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user } = useAuth();
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    if (user) {
      navigate('/financial-dashboard-overview');
    }

    // Check for URL parameters from callback
    const error = searchParams?.get('error');
    const message = searchParams?.get('message');

    if (error === 'verification_failed') {
      setNotification({
        type: 'error',
        message: 'Falha na verificação do e-mail. Por favor, tente novamente.'
      });
    } else if (message === 'please_login') {
      setNotification({
        type: 'info',
        message: 'Por favor, faça login para continuar.'
      });
    }
  }, [user, navigate, searchParams]);

  return (
    <>
      <Helmet>
        <title>Login - JR Wise Financial Control</title>
        <meta name="description" content="Sistema de controle financeiro para agências de viagens" />
      </Helmet>
      <div className="min-h-screen bg-gradient-to-br from-background via-card to-background flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <div className="flex items-center justify-center gap-3 mb-2">
              <Icon name="Plane" size={32} className="text-primary" />
              <h1 className="text-3xl font-bold text-foreground">JR Wise Tour</h1>
            </div>
            <p className="text-muted-foreground">Sistema de Controle Financeiro</p>
          </div>

          {notification && (
            <div className={`mb-6 p-4 rounded-lg border ${
              notification?.type === 'error' ?'bg-error/10 border-error/20 text-error' :'bg-info/10 border-info/20 text-info'
            }`}>
              <div className="flex items-start gap-3">
                <Icon 
                  name={notification?.type === 'error' ? 'AlertCircle' : 'Info'} 
                  size={20} 
                  className="flex-shrink-0 mt-0.5" 
                />
                <p className="text-sm">{notification?.message}</p>
              </div>
            </div>
          )}

          <div className="bg-card rounded-2xl shadow-xl border border-border p-8">
            <LoginForm onLoginSuccess={() => navigate('/financial-dashboard-overview')} />
          </div>

          <div className="mt-6 text-center text-xs text-muted-foreground">
            <p>© 2024 JR Wise Tour. Todos os direitos reservados.</p>
          </div>
        </div>
      </div>
    </>
  );
}